var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile_terminal_my"},[_c('el-button',{on:{"click":function($event){return _vm.openScan()}}},[_vm._v("扫描")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }